module.exports = __webpack_public_path__ + "static/media/bnr-sangyoisankokuminkaigi.2e1efb24.png";